export interface ScopeNode {
  uuid: string
  parentUuids: string[]
  nameRu?: string | null
  nameKz?: string | null
  type?: string | null
  orgUuid?: string | null
}

export interface ScopeTreeOption {
  value: string
  label: string
  children?: ScopeTreeOption[]
}

export function scopeLabel(node: ScopeNode, locale: string): string {
  const kz = locale === 'kk' ? node.nameKz : null
  return kz || node.nameRu || node.nameKz || node.uuid
}

// Дерево для el-tree-select: родитель — первый из parentUuids, который есть в
// списке; остальные узлы — корни. Узлы сортируются по названию.
export function buildScopeTree(nodes: ScopeNode[], locale: string): ScopeTreeOption[] {
  const byUuid = new Map(nodes.map(n => [n.uuid, {value: n.uuid, label: scopeLabel(n, locale), children: [] as ScopeTreeOption[]}]))
  const roots: ScopeTreeOption[] = []
  for (const n of nodes) {
    const option = byUuid.get(n.uuid)!
    const parent = n.parentUuids.map(p => byUuid.get(p)).find(Boolean)
    if (parent) {
      parent.children!.push(option)
    } else {
      roots.push(option)
    }
  }

  const sortTree = (list: ScopeTreeOption[]) => {
    list.sort((a, b) => a.label.localeCompare(b.label, 'ru'))
    for (const item of list) {
      if (item.children?.length) {
        sortTree(item.children)
      } else {
        delete item.children
      }
    }
  }
  sortTree(roots)
  return roots
}
